import {
	ADD_GEAR,
	ADD_GEAR_MESH_FREQUENCY,
	ADD_GEARBOX_STAGE,
	ADD_SHAFT_BEARING,
	ADD_TURBINE_SHAFTS,
	REMOVE_GEAR,
	REMOVE_GEAR_MESH_FREQUENCY,
	REMOVE_GEARBOX_STAGE,
	REMOVE_TURBINE_SHAFTS,
	SET_GEAR,
	SET_GEAR_MESH_FREQUENCY,
	SET_GEARBOX_MODEL,
	SET_GEARBOX_STAGES,
	SET_TURBINE_PROPERTIES,
	SET_TURBINE_PROPERTIES_VALIDITY,
	SET_GEAR_MESH_FREQUENCIES_VALIDITY,
	SET_SHAFTS_VALIDITY,
	SET_GEARS_VALIDITY,
	SET_GEARBOX_VALIDITY,
	SET_EFFECTIVE_SINCE_VALIDITY,
	SET_TURBINE_SHAFTS,
	SET_TURBINE_VERSIONS,
	SHOW_TOAST_MESSAGE,
	ENABLE_FORMS,
	SET_SHAFTS_BEARING_VALIDITY
} from "./KinematicConfiguratorActionsType";
import { RESET_STATE } from "@/stores/CommumActionTypes";
import {
	TurbineShaftsFactory, TurbineVersionFactory,
	GearsFactory,
	TurbinePropertiesFactory,
	GearboxStagesFactory,
	GearsMeshFrequenciesFactory,
	GearboxFactory,
} from "../factories/KinematicParametersFactory";
import ToastMessageType from "@/constants/enums/ToastMessageType";

const mutations = {
	/**
	 * Define as propriedades da turbina.
	 * @param {Object} properties - Objeto contendo as propriedades da turbina.
	 */
	[SET_TURBINE_PROPERTIES](state, properties)
	{
	  state.turbineProperties = properties;
	},

	/**
	 * Define a validade das propriedades da turbina.
	 * @param {boolean} isValid
	 */
	[SET_TURBINE_PROPERTIES_VALIDITY](state, isValid)
	{
	  state.turbinePropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades da gearbox.
	 * @param {boolean} isValid
	 */
	[SET_GEARBOX_VALIDITY](state, isValid)
	{
	  state.gearboxPropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades dos eixos/rolamentos.
	 * @param {boolean} isValid
	 */
	[SET_SHAFTS_VALIDITY](state, isValid)
	{
	  state.shaftPropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades dos rolamentos de um eixo.
	 * @param {boolean} isValid
	 */
	[SET_SHAFTS_BEARING_VALIDITY](state, isValid)
	{
	  state.shaftBearingPropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades de engrenagens.
	 * @param {boolean} isValid
	 */
	[SET_GEARS_VALIDITY](state, isValid)
	{
	  state.gearsPropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades de frequência de engrenamento.
	 * @param {boolean} isValid
	 */
	[SET_GEAR_MESH_FREQUENCIES_VALIDITY](state, isValid)
	{
	  state.gearMeshFrequencyPropertiesValid = isValid;
	},

	/**
	 * Define a validade das propriedades da data de vigência.
	 * @param {boolean} isValid
	 */
	[SET_EFFECTIVE_SINCE_VALIDITY](state, isValid)
	{
	  state.effectiveSincePropertiesValid = isValid;
	},

	/**
	 * Define o modelo da gearbox.
	 * @param {Object} gearbox - Objeto representando o modelo da gearbox.
	 */
	[SET_GEARBOX_MODEL](state, gearbox)
	{
	  state.gearbox = gearbox;
	},

	/**
	 * Define os estágios da caixa de engrenagens.
	 * @param {Array} stages - Lista de estágios da gearbox.
	 */
	[SET_GEARBOX_STAGES](state, stages)
	{
		state.gearboxStages = stages;
	},

	/**
	 * Adiciona um estágio à lista de estágios da gearbox.
	 * @param {Object} stage - Objeto representando um estágio.
	 */
	[ADD_GEARBOX_STAGE](state, stage)
	{
		state.gearboxStages.push(stage);
	},

	/**
	 * Remove um estágio da lista de estágios da gearbox por índice.
	 * @param {number} index - Índice do estágio a ser removido.
	 */
	[REMOVE_GEARBOX_STAGE](state, index)
	{
	  state.gearboxStages.splice(index, 1);
	},

	/**
	 * Define os eixos da turbina.
	 * @param {Array} shafts - Lista de eixos da turbina.
	 */
	[SET_TURBINE_SHAFTS](state, shafts)
	{
		state.shafts = shafts;
	},

	/**
	 * Adiciona um eixo à lista de eixos da turbina.
	 * @param {Object} shaft - Objeto representando um eixo da turbina.
	 */
	[ADD_TURBINE_SHAFTS](state, shaft)
	{
		state.shafts.push(shaft);
	},

	/**
	 * Adiciona um rolamento a um eixo específico.
	 * @param {Object} payload - Contém o índice do eixo e o objeto do rolamento.
	 * @param {number} payload.index - Índice do eixo.
	 * @param {Object} payload.bearing - Objeto representando o rolamento.
	 */
	[ADD_SHAFT_BEARING](state, { index, bearing })
	{
	  state.shafts[index].bearings.push(bearing);
	},

	/**
	 * Remove um eixo da lista por índice.
	 * @param {number} index - Índice do eixo a ser removido.
	 */
	[REMOVE_TURBINE_SHAFTS](state, index)
	{
	  state.shafts.splice(index, 1);
	},

	/**
	 * Adiciona uma engrenagem à lista.
	 * @param {Object} gear - Objeto representando a engrenagem.
	 */
	[ADD_GEAR](state, gear)
	{
	  state.gears.push(gear);
	},

	/**
	 * Remove uma engrenagem da lista por índice.
	 * @param {number} index - Índice da engrenagem a ser removida.
	 */
	[REMOVE_GEAR](state, index)
	{
	  state.gears.splice(index, 1);
	},

	/**
	 * Define a lista de engrenagens.
	 * @param {Array} gears - Lista de engrenagens.
	 */
	[SET_GEAR](state, gears)
	{
		state.gears = gears;
	},

	/**
	 * Define a lista de frequências de malha das engrenagens.
	 * @param {Array} frequencies - Lista de frequências.
	 */
	[SET_GEAR_MESH_FREQUENCY](state, frequencies)
	{
		state.gearsMeshFrequencies = frequencies;
	},

	/**
	 * Adiciona uma frequência de malha à lista.
	 * @param {Object} frequency - Objeto representando a frequência.
	 */
	[ADD_GEAR_MESH_FREQUENCY](state, frequency)
	{
	  state.gearsMeshFrequencies.push(frequency);
	},

	/**
	 * Remove uma frequência de malha da lista por índice.
	 * @param {number} index - Índice da frequência a ser removida.
	 */
	[REMOVE_GEAR_MESH_FREQUENCY](state, index)
	{
	  state.gearsMeshFrequencies.splice(index, 1);
	},

	/**
	 * Define a lista de versões da turbina.
	 * @param {Array} versions - Lista de versões do modelo da turbina.
	 */
	[SET_TURBINE_VERSIONS](state, versions)
	{
	  state.turbineVersionsModel = versions;
	},

	/**
	 * Habilita os formulários dos componentes da turbina.
	 */
	[ENABLE_FORMS](state, isDisabled)
	{
		state.isFormDisabled = isDisabled;
	},

	/**
	 * Define valores para exibição da toastMessage.
	 */
	[SHOW_TOAST_MESSAGE](state, { message, type })
	{
		state.toast.type = type;
		state.toast.message = message;
		state.toast.show = true;
	},

	/**
	 * Reseta o estado
	 */
	[RESET_STATE](state)
	{
		state.turbineProperties =                TurbinePropertiesFactory();
		state.turbinePropertiesValid =           false;
		state.gearboxPropertiesValid =           false;
		state.shaftPropertiesValid =             false;
		state.shaftBearingPropertiesValid =      false;
		state.gearsPropertiesValid =             false;
		state.gearMeshFrequencyPropertiesValid = false;
		state.effectiveSincePropertiesValid =    false;
		state.turbineVersionsModel =             TurbineVersionFactory();
		state.shafts =                           [ TurbineShaftsFactory() ];
		state.gearbox =                          GearboxFactory();
		state.gearboxStages =                    [ GearboxStagesFactory() ];
		state.gearsMeshFrequencies =             [ GearsMeshFrequenciesFactory() ];
		state.gears =                            [ GearsFactory() ];
		state.toast =                            {
			show:    false,
			message: "",
			type:    ToastMessageType.ERROR
		};
		state.isFormDisabled = true;
	},
};

export default { mutations };
